import { memo } from "react";

import { StaffShiftCreated } from "~/api/eventLog/events";

import { EventLog } from "@/api";
import { ShiftV2 } from "@/common/components/Shift/ShiftV2";
import { Author } from "@/common/components/StaffShiftHistoryModal/helpers/Author";
import { StaffAndDay } from "@/common/components/StaffShiftHistoryModal/helpers/StaffAndDay";
import { useCurrentUnitId } from "@/common/hooks";

import { IEventLogComponent } from "../index";

import { ShiftDetails } from "./helpers";

export const StaffShiftCreatedV1 = memo(
  ({
    event,
    indexedShiftTypes,
    usersById,
    unitIdByScheduleId,
  }: IEventLogComponent<
    EventLog.DTO<StaffShiftCreated.PayloadByVersion[StaffShiftCreated.EVersions.v1]>
  >) => {
    const staffShift = event.eventPayload.staffShift;
    const shiftType = indexedShiftTypes?.[staffShift.scheduleId]?.[staffShift.shiftTypeKey];
    const [staffId] = event.filterValues.staffIds ?? [];

    const unitIdFromShift = unitIdByScheduleId?.[event.eventPayload.staffShift.scheduleId];
    const currentUnitId = useCurrentUnitId();
    const unitId = unitIdFromShift || currentUnitId;

    return (
      <>
        <Author authorId={event.authorId} usersById={usersById} /> created a{" "}
        {shiftType ? <ShiftV2 variant="small" shiftType={shiftType} /> : ""} shift for{" "}
        <StaffAndDay staffId={staffId} usersById={usersById} date={staffShift.date} />.
        <ShiftDetails
          origin={event.eventPayload.origin}
          staffShift={event.eventPayload.staffShift}
          unitId={unitId}
        />{" "}
      </>
    );
  },
);
